<template>
  <expandable-material-card
    :title="$t('components.portal.advanced_settings')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="settings"
  >
    <v-card-actions>
      <v-spacer />
      <v-btn :disabled="allExpanded" text @click="all">
        {{ $t("globals.expand_all") }}
      </v-btn>
      <v-btn :disabled="allCollapsed" text @click="none">
        {{ $t("globals.collapse_all") }}
      </v-btn>
    </v-card-actions>
    <v-card-text>
      <v-expansion-panels
        v-model="panel"
        style="margin-top:10px"
        multiple
        v-if="portal !== null && portal !== undefined"
      >
        <dashboard-item-types-table
          :items="portal.dashboardItemTypes"
          @update="$emit('update-dashboard-item-types', $event)"
        />
        <pension-information-items-table
          v-if="portal.isPensionsPortal"
          :items="portal.pensionInformationItems"
          @update="$emit('update-pension-information-items', $event)"
        />

        <member-information-items-table
          :items="portal.memberInformationItems"
          @update="$emit('update-member-information-items', $event)"
          :selectedLanguages="selectedLanguages"
        />
        <horizontal-menu-items-table
          :items="portal.horizontalMenuItems"
          @update="$emit('update-horizontal-menu-items', $event)"
        />
        <member-registration-card
          :dataContainer="dataContainer"
          @update="portal = $event"
          @valid="valid = $event"
        />
      </v-expansion-panels>
    </v-card-text>
  </expandable-material-card>
</template>

<script>
import { mapGetters } from "vuex";
import ExpandableMaterialCard from "./ExpandableMaterialCard.vue";
import MemberRegistrationCard from "./MemberRegistrationCard.vue";
import MemberInformationItemsTable from "./MemberInformationItemsTable.vue";
import HorizontalMenuItemsTable from "./HorizontalMenuItemsTable.vue";
import DashboardItemTypesTable from "./DashboardItemTypesTable.vue";
import PensionInformationItemsTable from "./PensionInformationItemsTable.vue";

export default {
  components: {
    ExpandableMaterialCard,
    MemberRegistrationCard,
    MemberInformationItemsTable,
    HorizontalMenuItemsTable,
    DashboardItemTypesTable,
    PensionInformationItemsTable,
  },
  props: ["dataContainer", "selectedLanguages"],
  data() {
    return {
      valid: false,
      portal: null,
      panel: [0, 1, 2, 3, 4],
      items: 5,
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    allExpanded() {
      return (
        JSON.stringify(this.panel) ===
        JSON.stringify([...Array(this.items).keys()].map((k, i) => i))
      );
    },
    allCollapsed() {
      return JSON.stringify(this.panel) === JSON.stringify([]);
    },
  },
  watch: {
    dataContainer: {
      handler(v) {
        if (v !== null && v !== undefined) {
          this.portal = JSON.parse(JSON.stringify(v.portal));
        }
      },
    },
    portal: {
      handler(v) {
        this.$emit("update", v);
      },
      deep: true,
    },
    valid: {
      handler(v) {
        console.log("advanced settings valid: ", v);
        this.$emit("valid", v);
      },
    },
  },
  mounted() {
    if (this.dataContainer !== null && this.dataContainer !== undefined) {
      this.portal = JSON.parse(JSON.stringify(this.dataContainer.portal));
      this.all();
      this.$nextTick(() => {
        this.$emit("valid", this.valid);
      });
    }
  },
  methods: {
    all() {
      this.panel = [...Array(this.items).keys()].map((k, i) => i);
    },
    none() {
      this.panel = [];
    },
  },
};
</script>
